import {connect} from "react-redux";
import Page from "./TeamDetailsPage.jsx";
import {loadTeamDetails} from "./teamDetailsActions";
const mapStateToProps = (state, {match}) => {
    return {
        match,
        team: state.teamDetails.team,
        loading: state.teamDetails.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (gameId, teamId) => dispatch(loadTeamDetails(gameId, teamId))
    }
};

const TeamDetailsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Page);

export default TeamDetailsPageContainer